class PopularColors {
    constructor() {
      this.fireMetrics();
      this.interactionCap = 5;
      this.curcount = 0;
    }

    fireMetrics(){
      return CustomInk.Metrics.fireEvent(
        'product listing page',
        'popular color swatch',
        'page load'
      );
    }

    fireInteraction(){
      if (this.curcount < 5) {
        this.curcount += 1;
        return CustomInk.Metrics.fireEvent(
          'product listing page',
          'popular color swatch',
          'hover'
        );
      }
      return null;
    }
  }

  ProductCatalog.PopularColors = new PopularColors();
